<template>
    <div class="detail">
        <div class="coverBgc">
            <img src="../../assets/news/bgc.png" alt="">
            <div class="title">关注最新资讯 掌握前沿动态</div>
        </div>
        <div class="detailContent">
            <div class="detailTitle">{{detail.title}}</div>
            <div class="news"><span class="industry">行业资讯</span><span class="time">{{detail.publishTime}}</span></div>
            <div class="content" v-html="detail.content"></div>
        </div>
        <!-- <div class="footerImg"><img src="../../assets/news/cover.png" alt=""></div> -->
        <!-- <Footer></Footer> -->
    </div>
</template>

<script>
import { newsDetail} from '@/api/news'
import to from 'await-to'
// import Footer from '@/components/footer'
export default {
    //  components: {Footer },
    data() {
        return {
            articleId:this.$route.query.articleId,
            detail:{}
        };
    },
    created() {
        this.newsDetailData()
    },
    methods: {
        async newsDetailData(){
            const [res,err ] = await to(newsDetail({articleId:this.articleId}))
            if (err) return this.$toast(err.msg)
                res.data.currentArticle.content = res.data.currentArticle.content.replace(
                    /<img/g,
                    "<img style='max-width: 100% !important;'",
                )
            this.detail = res.data.currentArticle
         
        }
    }
};
</script>

<style scoped lang="scss">
.detail{
    .coverBgc{
        height: 320px;
        position: relative;
        .title{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            font-size: 42px;
            font-weight: 500;
            color: #fff;
            width: 100%;
            text-align: center;
        }
    }
    .detailContent{
        padding: 26px 0 42px 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        .detailTitle{
            font-size: 21px;
            font-weight: 500;
            color: #000;
        }
        .news{
            display: flex;
            align-items: center;
            margin: 10px 0 33px 0;
            .industry{
                padding: 2px 5px;
                color: #fff;
                background: #004a9f;
                font-size: 12px;
            }
            .time{
                color: #444444;
                font-size: 14px;
                margin-left: 16px;
            }
        }
        .content{
            color: #555555;
            font-size: 16px;
            width: 90%;
        }
    }
    .footerImg{
        height: 191px;
        padding: 20px;
        padding-top: 0;
    }
    img{
        width: 100%;
        height: 100%;
    }
}
</style>
